import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 25,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 20"
    >
<path d="M25.1012 11.6229L20.2862 6.81256L13.2644 13.8277L20.2702 20.8268L25.0852 16.0164C25.3813 15.7326 25.6173 15.3922 25.779 15.0154C25.9406 14.6385 26.0247 14.2331 26.0262 13.8231C26.0277 13.4131 25.9466 13.007 25.7877 12.629C25.6288 12.2511 25.3953 11.9089 25.1012 11.6229V11.6229Z" fill="#F26B4B"/>
<path d="M6.25056 6.78851L1.43558 11.5989C1.14903 11.8829 0.92158 12.2207 0.766369 12.5929C0.611157 12.9651 0.53125 13.3644 0.53125 13.7676C0.53125 14.1708 0.611157 14.57 0.766369 14.9423C0.92158 15.3145 1.14903 15.6523 1.43558 15.9363L6.25056 20.7466L13.2644 13.8277L6.25056 6.78851Z" fill="#AB58A2"/>
<path d="M15.3267 1.85784C15.056 1.58562 14.734 1.36958 14.3794 1.22216C14.0247 1.07474 13.6444 0.99884 13.2603 0.99884C12.8762 0.99884 12.4958 1.07474 12.1412 1.22216C11.7866 1.36958 11.4646 1.58562 11.1939 1.85784L6.25049 6.78848L13.2643 13.8277L20.2701 6.82857L15.3267 1.85784Z" fill="#3CC4E3"/>
    </svg>
  );
};

export default LogoIcon;
